import React, { useCallback } from 'react';
import Tippy from '@tippyjs/react';
import cx from 'classnames';
import { ToggleHiddenLogsStyles } from '../styled';

import { ReactComponent as EyeOnIcon } from 'assets/icons/eye-on.svg';
import { ReactComponent as EyeOffIcon } from 'assets/icons/eye-off.svg';

import { sendEventToSegment } from 'redux/modules/analytics';
import { TOGGLE_LOGS_VISIBLE } from 'redux/modules/analytics/events';

const t = {
  show: 'Show hidden log entries',
  hide: 'Hide irrelevant log entries',
};

const ToggleHiddenLogs = ({ hideSomeLogs, setHideSomeLogs, className }) => {
  const handleClick = useCallback(() => {
    setHideSomeLogs(!hideSomeLogs);
    sendEventToSegment(TOGGLE_LOGS_VISIBLE);
  }, [hideSomeLogs, setHideSomeLogs]);

  return (
    <Tippy
      placement="bottom"
      interactive
      maxWidth="none"
      content={<span>{hideSomeLogs ? t.show : t.hide}</span>}
    >
      <div
        onClick={handleClick}
        className={cx(className, { 'togleHiddenLogs--hidden': hideSomeLogs })}
        data-testid="ToggleHiddenLogs"
      >
        {hideSomeLogs ? <EyeOffIcon /> : <EyeOnIcon />}
      </div>
    </Tippy>
  );
};

export default ToggleHiddenLogsStyles(ToggleHiddenLogs);
